import {
  PieChartOutlined,
  PullRequestOutlined,
  QuestionCircleOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Layout, Menu } from "antd";
import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import CheckPermission from "../../../Util/CheckPermission";
import { connect } from "react-redux";
import HowToVoteIcon from "@mui/icons-material/HowToVote";

const Reports = ({ permissions }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedNav, setSelectedNav] = useState("");

  let items = [];
  if (CheckPermission("users_status_list", permissions)) {
    items.push({
      icon: <UserOutlined />,
      label: <Link to="/reports/users">کاربران</Link>,
      key: "users",
    });

    items.push({
      icon: <PullRequestOutlined />,
      label: <Link to="/reports/consulting-requests">درخواست مشاوره</Link>,
      key: "consulting-requests",
    });
  }
  // monitoring_history
  if (CheckPermission("monitoring_history", permissions)) {
    items.push({
      icon: <PieChartOutlined />,
      label: <Link to="/reports/operators">گزارش اپراتور ها</Link>,
      key: "operators",
    });
  }
  if (CheckPermission("reports_answers_note_count", permissions)) {
    items.push({
      icon: <QuestionCircleOutlined />,
      label: <Link to="/reports/questions">سوالات</Link>,
      key: "questions",
    });
  }
  if (CheckPermission("roadmap_votes", permissions)) {
    items.push({
      icon: <HowToVoteIcon />,
      label: <Link to="/reports/vote-report">نظرات میانه مسیر</Link>,
      key: "vote-report",
    });
  }

  useEffect(() => {
    if (location.pathname === "/reports") {
      navigate("/reports/users");
      setSelectedNav("");
      // setTimeout(()=>{
      //   setSelectedNav('')
      // } , 1)
    }
    items.forEach((el) => {
      if (!el) {
        return;
      }
      if (`/reports/${el.key}` == location.pathname) {
        setSelectedNav(el.key);
      }
    });
  }, [location]);

  return (
    <Layout
      style={{
        padding: "24px 0",
        background: "white",
      }}
    >
      <Layout.Sider
        style={{
          background: "white",
        }}
        width={200}
      >
        <Menu
          mode="inline"
          selectedKeys={[selectedNav]}
          style={{
            height: "100%",
          }}
          items={items}
        />
      </Layout.Sider>
      <Layout.Content
        style={{
          padding: "0 24px",
          height: "100%",
          borderRadius: "6px",
        }}
      >
        <Outlet />
      </Layout.Content>
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    permissions: state.userData ? state.userData.permissions : [],
  };
};
export default connect(mapStateToProps)(Reports);
